import React from "react";
import { FaUser } from "react-icons/fa";

const TestimonialCard = ({name,feedback }) => {
  return (
    <div className="w-full h-[30rem] bg-[#143B51] rounded-md p-8 flex flex-col gap-4 relative mx-auto mt-[2rem] ">
      <p className="text-[#bfbfbf] text-base sm:text-lg font-medium text-justify mt-[2rem]">
        {feedback}
      </p>

      <div className="flex flex-col mt-[1rem]">
        <h3 className="text-xl sm:text-2xl font-semibold text-[#bfbfbf]">{name}</h3>
        <p className="text-sm sm:text-base font-medium text-[#bfbfbf]">
         
          (অভিভাবক)
        </p>
        
      </div>

      <div className="absolute top-[-2rem] left-1/2 transform -translate-x-1/2 w-[4rem] h-[4rem] bg-gray-300 rounded-full flex justify-center items-center">
    

        <FaUser className="text-4xl" />
      </div>
    </div>
  );
};

export default TestimonialCard;

